import { Button, ButtonProps, styled, Typography } from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface Props extends ButtonProps {
  isActive: boolean;
}

export default function TagToggleButton(props: Props) {
  const { isActive, ...buttonProps } = props;
  const { t } = useTranslation();

  return (
    <StyledButton {...buttonProps}>
      <Typography variant="subtitle1" color={isActive ? "primary" : ""} noWrap>
        <FilterAlt />
        {isActive && t("label.closeFilter")}
        {!isActive && t("label.filterResults")}
      </Typography>
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  .MuiTypography-root {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;
